import React, { useMemo, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Badge,

} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useAddEtudiantMutation,
  useDeleteEtudiantMutation,
  useFetchEtudiantsQuery,
  useBulkCreateEtudiantsMutation,
  useBulkDeleteEtudiantsMutation,
  useBulkUpdateClasseMutation,
} from "features/etudiants/etudiantSlice";
import Select from "react-select";
import * as XLSX from "xlsx";
import Flatpickr from "react-flatpickr";
import { useFetchClassesQuery } from "features/classes/classeSlice";
import { useFetchParentsQuery } from "features/parents/parentSlice";
import { French } from "flatpickr/dist/l10n/fr";
import { convertToBase64 } from "helpers/base64_convert";
import { formatDate } from "helpers/data_time_format";
import { validateAllRows, ValidatedRow } from "helpers/import_validation";

const Etudiants = () => {
  const { data = [] } = useFetchEtudiantsQuery();
  const { data: AllClasses = [] } = useFetchClassesQuery();
  const { data: AllParents = [] } = useFetchParentsQuery();

  const [deleteEtudiant] = useDeleteEtudiantMutation();

  const [selectedDateDeNaissance, setSelectedDateDeNaissance] =
    useState<Date | null>(null);
  const handleDateDeNaissanceChange = (selectedDates: Date[]) => {
    setSelectedDateDeNaissance(selectedDates[0]);
  };

  const notifySuccess = () => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "L'élève a été créé avec succès",
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Une erreur est survenue: ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteEtudiant(_id);
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "L'élève est supprimé.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "L'élève est en sécurité :)",
            "info"
          );
        }
      });
  };

  const [selectedClasse, setSelectedClasse] = useState<string>("");

  const handleSelectClasse = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedClasse(value);
  };

  const [selectedGenre, setSelectedGenre] = useState<string>("");

  const handleSelectGenre = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedGenre(value);
  };

  const [modal_AddEtudiant, setmodal_AddEtudiant] = useState<boolean>(false);
  function tog_AddEtudiant() {
    setmodal_AddEtudiant(!modal_AddEtudiant);
  }

  const [createEtudiant] = useAddEtudiantMutation();

  const initialEtudiant = {
    nom: "",
    prenom: "",
    date_de_naissance: "",
    classe: "",
    genre: "",
    avatar_base64_string: "",
    avatar_extension: "",
    avatar: "",
    statusPaiement: "",
    lieu_naissance: "",
    adresse_eleve: "",
    ville: "",
    nationalite: "",
    annee_scolaire: "",
    etablissement_frequente: "",
    moyenne_trimestre_1: "",
    moyenne_trimestre_2: "",
    moyenne_trimestre_3: "",
    moyenne_annuelle: "",
    moyenne_concours_6: "",
    numero_convocation_concours: "",
  };

  const [etudiant, setEtudiant] = useState(initialEtudiant);

  const {
    nom,
    prenom,
    date_de_naissance,
    classe,
    genre,
    avatar_base64_string,
    avatar_extension,
    avatar,
    statusPaiement,
    lieu_naissance,
    adresse_eleve,
    ville,
    nationalite,
    annee_scolaire,
    etablissement_frequente,
    moyenne_trimestre_1,
    moyenne_trimestre_2,
    moyenne_trimestre_3,
    moyenne_annuelle,
    moyenne_concours_6,
    numero_convocation_concours,
  } = etudiant;

  const onChangeEtudiant = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEtudiant((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = (
      document.getElementById("avatar_base64_string") as HTMLFormElement
    ).files[0];
    if (file) {
      const { base64Data, extension } = await convertToBase64(file);
      const profileImage = base64Data + "." + extension;
      setEtudiant({
        ...etudiant,
        avatar: profileImage,
        avatar_base64_string: base64Data,
        avatar_extension: extension,
      });
    }
  };

  const [selectedParent, setSelectedParent] = useState<string>("");

  const onSubmitEtudiant = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const payload = {
        ...etudiant,
        date_de_naissance: formatDate(selectedDateDeNaissance),
        classe: selectedClasse,
        genre: selectedGenre,
        parent: selectedParent,
        statusPaiement: "0",
      };
      createEtudiant(payload)
        .then(() => {
          notifySuccess();
          setEtudiant(initialEtudiant);
          setSelectedClasse("");
          setSelectedGenre("");
          setSelectedParent("");
          setSelectedDateDeNaissance(null);
          setmodal_AddEtudiant(false);
        });
    } catch (error) {
      notifyError(error);
    }
  };

  // --- Stats ---
  const stats = useMemo(() => {
    const total = data.length;
    const garcons = data.filter((e: any) => e.genre === "Mâle").length;
    const filles = data.filter((e: any) => e.genre === "Femelle").length;
    const classeSet = new Set(data.map((e: any) => e.classe?.nom_classe).filter(Boolean));
    return { total, garcons, filles, nbClasses: classeSet.size };
  }, [data]);

  // --- Filters ---
  const [searchTerm, setSearchTerm] = useState("");
  const [filterClasse, setFilterClasse] = useState("");
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const getFilteredEtudiants = () => {
    let filteredEtudiants = [...data];

    if (filterClasse) {
      filteredEtudiants = filteredEtudiants.filter(
        (etudiant: any) => etudiant?.classe?.nom_classe === filterClasse
      );
    }

    if (searchTerm) {
      filteredEtudiants = filteredEtudiants.filter(
        (etudiant: any) =>
          etudiant?.nom!.toLowerCase().includes(searchTerm.toLowerCase()) ||
          etudiant?.prenom!.toLowerCase().includes(searchTerm.toLowerCase()) ||
          etudiant?.classe
            ?.nom_classe!.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          etudiant
            ?.date_de_naissance!.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          etudiant?.parent
            ?.nom_parent!.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          etudiant?.parent
            ?.prenom_parent!.toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
    }

    return filteredEtudiants.reverse();
  };

  const classeOptions = useMemo(() => {
    const names = Array.from(new Set(data.map((e: any) => e.classe?.nom_classe).filter(Boolean)));
    return names.sort();
  }, [data]);

  const columns = [
    {
      name: <span className="fw-semibold fs-13">Élève</span>,
      selector: (row: any) => `${row.prenom} ${row.nom}`,
      cell: (row: any) => {
        const hasAvatar = row.avatar_base64_string && row.avatar_base64_string !== "";
        const initials = `${(row.prenom || "")[0] || ""}${(row.nom || "")[0] || ""}`.toUpperCase();
        return (
          <div className="d-flex align-items-center gap-2">
            <div className="avatar-xs flex-shrink-0">
              {hasAvatar ? (
                <img
                  src={`data:image/jpeg;base64,${row.avatar_base64_string}`}
                  alt={initials}
                  className="rounded-circle img-fluid"
                  style={{ width: 32, height: 32, objectFit: "cover" }}
                />
              ) : (
                <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-14 fw-semibold">
                  {initials}
                </div>
              )}
            </div>
            <div>
              <span className="fw-medium fs-13">{row.prenom} {row.nom}</span>
              {row.genre && (
                <Badge
                  bg={row.genre === "Mâle" ? "info-subtle" : "danger-subtle"}
                  text={(row.genre === "Mâle" ? "info" : "danger") as any}
                  className="ms-2 fs-10"
                >
                  {row.genre === "Mâle" ? "M" : "F"}
                </Badge>
              )}
            </div>
          </div>
        );
      },
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="fw-semibold fs-13">Date de Naissance</span>,
      selector: (row: any) => row.date_de_naissance,
      cell: (row: any) => (
        <span className="text-muted fs-13">
          <i className="ri-calendar-line me-1 text-primary" />
          {row.date_de_naissance}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Classe</span>,
      selector: (row: any) => row.classe?.nom_classe!,
      cell: (row: any) => (
        <Badge bg="secondary-subtle" text={"secondary" as any} className="fs-12 px-2 py-1">
          <i className="ri-book-2-line me-1" />
          {row.classe?.nom_classe || "—"}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Parent</span>,
      selector: (row: any) => `${row?.parent?.nom_parent || ""} ${row?.parent?.prenom_parent || ""}`,
      cell: (row: any) => (
        <span className="fs-13">
          <i className="ri-parent-line me-1 text-muted" />
          {row?.parent?.nom_parent!} {row?.parent?.prenom_parent!}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Actions</span>,
      cell: (row: any) => (
        <div className="d-flex gap-1">
          <Link
            to="/détails-etudiant"
            className="btn btn-soft-info btn-sm btn-icon"
            state={row}
            title="Voir détails"
          >
            <i className="ri-eye-line" />
          </Link>
          <Link
            to="/modifier-etudiant"
            className="btn btn-soft-success btn-sm btn-icon"
            state={row}
            title="Modifier"
          >
            <i className="ri-edit-2-line" />
          </Link>
          <button
            className="btn btn-soft-danger btn-sm btn-icon"
            onClick={() => AlertDelete(row._id)}
            title="Supprimer"
          >
            <i className="ri-delete-bin-2-line" />
          </button>
        </div>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f3f6f9",
        fontWeight: "600",
        fontSize: "13px",
        color: "#495057",
        borderBottom: "2px solid #e9ebec",
      },
    },
    rows: {
      style: {
        fontSize: "13px",
        "&:hover": {
          backgroundColor: "#f3f6f9",
        },
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e9ebec",
      },
    },
  };

  const [bulkCreateEtudiants] = useBulkCreateEtudiantsMutation();
  const [bulkDeleteEtudiants] = useBulkDeleteEtudiantsMutation();
  const [bulkUpdateClasse] = useBulkUpdateClasseMutation();

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [modal_BulkClasse, setModal_BulkClasse] = useState(false);
  const [bulkTargetClasse, setBulkTargetClasse] = useState("");

  const handleRowSelected = (state: any) => {
    setSelectedRows(state.selectedRows);
  };

  const handleBulkDelete = async () => {
    const count = selectedRows.length;
    const result = await swalWithBootstrapButtons.fire({
      title: `Supprimer ${count} élève(s) ?`,
      text: "Cette action est irréversible.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Oui, supprimer ${count}`,
      cancelButtonText: "Annuler",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const ids = selectedRows.map((r: any) => r._id);
        const res = await bulkDeleteEtudiants({ ids }).unwrap();
        Swal.fire("Supprimé !", `${res.deleted} élève(s) supprimé(s).`, "success");
        setToggleCleared(!toggleCleared);
        setSelectedRows([]);
      } catch (err: any) {
        Swal.fire("Erreur", err?.data?.message || "Erreur lors de la suppression", "error");
      }
    }
  };

  const handleBulkChangeClasse = async () => {
    if (!bulkTargetClasse) return;
    const count = selectedRows.length;
    try {
      const ids = selectedRows.map((r: any) => r._id);
      const res = await bulkUpdateClasse({ ids, classe: bulkTargetClasse }).unwrap();
      Swal.fire("Modifié !", `${res.modified} élève(s) déplacé(s).`, "success");
      setModal_BulkClasse(false);
      setBulkTargetClasse("");
      setToggleCleared(!toggleCleared);
      setSelectedRows([]);
    } catch (err: any) {
      Swal.fire("Erreur", err?.data?.message || "Erreur lors du changement", "error");
    }
  };

  const handleBulkExport = () => {
    const exportData = selectedRows.map((r: any) => ({
      Nom: r.nom,
      Prénom: r.prenom,
      "Date de Naissance": r.date_de_naissance,
      Genre: r.genre,
      Classe: r.classe?.nom_classe || "",
      "Nom Parent": r.parent?.nom_parent || "",
      "Prénom Parent": r.parent?.prenom_parent || "",
      "Tél Parent": r.parent?.phone || "",
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    ws["!cols"] = Object.keys(exportData[0] || {}).map(() => ({ wch: 20 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Élèves");
    XLSX.writeFile(wb, `eleves_selection_${selectedRows.length}.xlsx`);
  };

  const [modal_Import, setmodal_Import] = useState<boolean>(false);
  const [validatedRows, setValidatedRows] = useState<ValidatedRow[]>([]);
  const [importLoading, setImportLoading] = useState(false);
  const [importResult, setImportResult] = useState<any>(null);

  const validCount = validatedRows.filter(r => r.valid).length;
  const errorCount = validatedRows.filter(r => !r.valid).length;
  const allValid = validatedRows.length > 0 && errorCount === 0;

  const templateColumns = [
    "nom_eleve", "prenom_eleve", "date_de_naissance", "genre",
    "lieu_naissance", "adresse_eleve", "ville", "nationalite",
    "classe", "annee_scolaire", "etablissement_frequente",
    "nom_parent", "prenom_parent", "phone_parent", "cin_parent", "profession_parent",
  ];

  const handleExportTemplate = () => {
    const ws = XLSX.utils.aoa_to_sheet([templateColumns]);
    ws["!cols"] = templateColumns.map(() => ({ wch: 20 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Elèves");
    XLSX.writeFile(wb, "template_eleves.xlsx");
  };

  const handleFileImport = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = evt.target?.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData: Record<string, any>[] = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      const classesInfo = AllClasses.map((c: any) => ({ _id: c._id, nom_classe: c.nom_classe }));
      const validated = validateAllRows(jsonData, classesInfo);
      setValidatedRows(validated);
      setImportResult(null);
    };
    reader.readAsBinaryString(file);
  };

  const handleBulkImport = async () => {
    if (!allValid) return;
    setImportLoading(true);
    try {
      const rows = validatedRows.map(r => r.normalized);
      const result = await bulkCreateEtudiants({ rows }).unwrap();
      setImportResult(result);
      Swal.fire({
        icon: result.errors?.length > 0 ? "warning" : "success",
        title: `${result.created} élève(s) créé(s)`,
        text: result.errors?.length > 0 ? `${result.errors.length} erreur(s) côté serveur` : "Import terminé avec succès",
      });
    } catch (err: any) {
      Swal.fire({ icon: "error", title: "Une erreur est survenue", text: err?.data?.message || "Erreur lors de l'import" });
    } finally {
      setImportLoading(false);
    }
  };

  const getCellClass = (row: ValidatedRow, field: string): string => {
    if (row.errors.some(e => e.field === field)) return "table-danger";
    if (row.corrected[field]) return "text-primary fw-semibold";
    return "";
  };

  const getCellTooltip = (row: ValidatedRow, field: string): string => {
    const err = row.errors.find(e => e.field === field);
    if (err) return err.suggestion ? `${err.message} — ${err.suggestion}` : err.message;
    if (row.corrected[field]) return `Auto-corrigé : "${row.original[field]}" → "${row.corrected[field]}"`;
    return "";
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Elèves" pageTitle="Tableau de bord" />

          {/* KPI Cards */}
          <Row className="mb-3">
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                        <i className="ri-group-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Total élèves</p>
                      <h4 className="mb-0">{stats.total}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-info-subtle text-info rounded-circle fs-3">
                        <i className="ri-men-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Garçons</p>
                      <h4 className="mb-0 text-info">{stats.garcons}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-danger-subtle text-danger rounded-circle fs-3">
                        <i className="ri-women-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Filles</p>
                      <h4 className="mb-0 text-danger">{stats.filles}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-success-subtle text-success rounded-circle fs-3">
                        <i className="ri-book-2-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Classes</p>
                      <h4 className="mb-0 text-success">{stats.nbClasses}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Data Table */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Header className="border-bottom-dashed bg-white">
                <Row className="g-3 align-items-center">
                  <Col lg={3} md={6}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher par nom, classe, parent..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={3} md={3}>
                    <select
                      className="form-select"
                      value={filterClasse}
                      onChange={(e) => setFilterClasse(e.target.value)}
                    >
                      <option value="">Toutes les classes</option>
                      {classeOptions.map((c: any) => (
                        <option value={c} key={c}>{c}</option>
                      ))}
                    </select>
                  </Col>
                  <Col lg={6} md={3} className="d-flex justify-content-end gap-2 flex-wrap">
                    {(filterClasse || searchTerm) && (
                      <Button
                        variant="soft-secondary"
                        size="sm"
                        onClick={() => { setFilterClasse(""); setSearchTerm(""); }}
                      >
                        <i className="ri-filter-off-line me-1" />
                        Réinitialiser
                      </Button>
                    )}
                    <Button
                      variant="soft-success"
                      size="sm"
                      onClick={handleExportTemplate}
                    >
                      <i className="ri-download-2-line me-1" />
                      Template Excel
                    </Button>
                    <Button
                      variant="soft-info"
                      size="sm"
                      onClick={() => { setmodal_Import(true); setValidatedRows([]); setImportResult(null); }}
                    >
                      <i className="ri-upload-2-line me-1" />
                      Importer Excel
                    </Button>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => tog_AddEtudiant()}
                      className="d-flex align-items-center gap-1"
                    >
                      <i className="ri-add-line fs-16" />
                      Ajouter Élève
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              {selectedRows.length > 0 && (
                <div className="bg-primary-subtle border-bottom px-3 py-2 d-flex align-items-center gap-2 flex-wrap">
                  <Badge bg="primary" className="fs-13 px-2 py-1">
                    {selectedRows.length} sélectionné(s)
                  </Badge>
                  <Button
                    variant="soft-warning"
                    size="sm"
                    onClick={() => setModal_BulkClasse(true)}
                  >
                    <i className="ri-exchange-line me-1" />
                    Changer de classe
                  </Button>
                  <Button
                    variant="soft-success"
                    size="sm"
                    onClick={handleBulkExport}
                  >
                    <i className="ri-file-excel-2-line me-1" />
                    Exporter sélection
                  </Button>
                  <Button
                    variant="soft-danger"
                    size="sm"
                    onClick={handleBulkDelete}
                  >
                    <i className="ri-delete-bin-2-line me-1" />
                    Supprimer sélection
                  </Button>
                  <Button
                    variant="soft-secondary"
                    size="sm"
                    onClick={() => { setToggleCleared(!toggleCleared); setSelectedRows([]); }}
                  >
                    <i className="ri-close-line me-1" />
                    Désélectionner
                  </Button>
                </div>
              )}
              <Card.Body className="p-0">
                <DataTable
                  columns={columns}
                  data={getFilteredEtudiants()}
                  pagination
                  paginationPerPage={15}
                  paginationRowsPerPageOptions={[10, 15, 25, 50]}
                  customStyles={customStyles}
                  selectableRows
                  selectableRowsVisibleOnly
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  noDataComponent={
                    <div className="text-center py-5">
                      <i className="ri-user-3-line fs-1 text-muted d-block mb-2" />
                      <p className="text-muted mb-0">Aucun élève trouvé</p>
                    </div>
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                  }}
                  highlightOnHover
                  responsive
                />
              </Card.Body>
            </Card>
          </Col>

          {/* Add Modal */}
          <Modal
            className="fade"
            id="createModal"
            show={modal_AddEtudiant}
            onHide={() => {
              tog_AddEtudiant();
            }}
            centered
            size="xl"
          >
            <Modal.Header closeButton className="bg-primary-subtle">
              <h5 className="modal-title">
                <i className="ri-user-add-line me-2" />
                Ajouter Élève
              </h5>
            </Modal.Header>
            <Modal.Body>
              <Form className="create-form" onSubmit={onSubmitEtudiant}>
                <Row>
                  <Col lg={7}>
                    <Card>
                      <Card.Header>
                        <h5>RENSEIGNEMENTS CONCERNANT L'ÉLÈVE</h5>
                      </Card.Header>
                      <Card.Body>
                        <Row className="mb-4">
                          <div className="text-center mb-3">
                            <div className="position-relative d-inline-block">
                              <div className="position-absolute top-100 start-100 translate-middle">
                                <label
                                  htmlFor="avatar_base64_string"
                                  className="mb-0"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="right"
                                  title="Choisir avatar pour élève"
                                >
                                  <span className="avatar-xs d-inline-block">
                                    <span className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                      <i className="ri-image-fill"></i>
                                    </span>
                                  </span>
                                </label>
                                <input
                                  className="form-control d-none"
                                  type="file"
                                  name="avatar_base64_string"
                                  id="avatar_base64_string"
                                  accept="image/*"
                                  onChange={(e) => handleFileUpload(e)}
                                />
                              </div>
                              <div className="avatar-lg">
                                <div className="avatar-title bg-light rounded-3">
                                  <img
                                    src={`data:image/jpeg;base64, ${etudiant.avatar_base64_string}`}
                                    alt={etudiant.nom}
                                    id="avatar_base64_string"
                                    className="img-thumbnail rounded-circle"
                                    width={200}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Row>
                        <Row className="mb-4"></Row>
                        <Row className="mb-4">
                          <Col lg={3}>
                            <Form.Label htmlFor="nom">Nom</Form.Label>
                          </Col>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="nom"
                              name="nom"
                              onChange={onChangeEtudiant}
                              value={etudiant.nom}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={3}>
                            <Form.Label htmlFor="prenom">Prénom</Form.Label>
                          </Col>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="prenom"
                              name="prenom"
                              onChange={onChangeEtudiant}
                              value={etudiant.prenom}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={3}>
                            <Form.Label htmlFor="prenom">
                              Date et Lieu de Naissance
                            </Form.Label>
                          </Col>
                          <Col lg={4}>
                            <Flatpickr
                              className="form-control flatpickr-input"
                              placeholder="Choisir date de Naissance"
                              onChange={handleDateDeNaissanceChange}
                              options={{
                                dateFormat: "d M, Y",
                                locale: French,
                              }}
                              id="startDate"
                              name="startDate"
                            />
                          </Col>
                          <Col lg={5}>
                            <Form.Control
                              type="text"
                              id="lieu_naissance"
                              name="lieu_naissance"
                              onChange={onChangeEtudiant}
                              placeholder="Lieu de Naissance"
                              value={etudiant.lieu_naissance}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={3}>
                            <Form.Label htmlFor="adresse_eleve">
                              Adresse
                            </Form.Label>
                          </Col>
                          <Col lg={4}>
                            <Form.Control
                              type="text"
                              id="adresse_eleve"
                              name="adresse_eleve"
                              onChange={onChangeEtudiant}
                              placeholder="Adresse"
                              value={etudiant.adresse_eleve}
                            />
                          </Col>
                          <Col lg={1}>
                            <Form.Label htmlFor="ville">Ville</Form.Label>
                          </Col>
                          <Col lg={4}>
                            <Form.Control
                              type="text"
                              id="ville"
                              name="ville"
                              onChange={onChangeEtudiant}
                              placeholder="Ville"
                              value={etudiant.ville}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={3}>
                            <Form.Label htmlFor="nationalite">
                              Nationalité
                            </Form.Label>
                          </Col>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="nationalite"
                              name="nationalite"
                              onChange={onChangeEtudiant}
                              value={etudiant.nationalite}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={3}>
                            <Form.Label htmlFor="genre">Genre</Form.Label>
                          </Col>
                          <Col lg={9}>
                            <select
                              className="form-select text-muted"
                              name="genre"
                              id="genre"
                              onChange={handleSelectGenre}
                            >
                              <option value="">Choisir</option>
                              <option value="Mâle">Mâle</option>
                              <option value="Femelle">Femelle</option>
                            </select>
                          </Col>
                        </Row>
                        <Row className="mb-4"></Row>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={5}>
                    <Card>
                      <Card.Header>
                        <h5>SCOLARITE ANTERIEURE</h5>
                      </Card.Header>
                      <Card.Body>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="classe">Classe</Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Select
                              options={[...AllClasses].sort((a, b) => (a.nom_classe || "").localeCompare(b.nom_classe || "", "fr")).map((classe) => ({
                                value: classe?._id!,
                                label: classe.nom_classe,
                              }))}
                              value={selectedClasse ? { value: selectedClasse, label: AllClasses.find((c: any) => c._id === selectedClasse)?.nom_classe || "" } : null}
                              onChange={(opt: any) => setSelectedClasse(opt?.value || "")}
                              placeholder="Rechercher une classe..."
                              isClearable
                              isSearchable
                              noOptionsMessage={() => "Aucune classe trouvée"}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="parent">Parent</Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Select
                              options={[...AllParents].sort((a: any, b: any) => (`${a.nom_parent} ${a.prenom_parent}`).localeCompare(`${b.nom_parent} ${b.prenom_parent}`, "fr")).map((parent: any) => ({
                                value: parent?._id,
                                label: `${parent.nom_parent} ${parent.prenom_parent} — ${parent.phone}`,
                              }))}
                              value={selectedParent ? { value: selectedParent, label: (() => { const p = AllParents.find((p: any) => p._id === selectedParent) as any; return p ? `${p.nom_parent} ${p.prenom_parent} — ${p.phone}` : ""; })() } : null}
                              onChange={(opt: any) => setSelectedParent(opt?.value || "")}
                              placeholder="Rechercher un parent..."
                              isClearable
                              isSearchable
                              noOptionsMessage={() => "Aucun parent trouvé"}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="numero_convocation_concours">
                              N° Convocation Concours
                            </Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="numero_convocation_concours"
                              name="numero_convocation_concours"
                              onChange={onChangeEtudiant}
                              value={etudiant.numero_convocation_concours}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="moyenne_concours_6">
                              Moyenne Concours
                            </Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="moyenne_concours_6"
                              name="moyenne_concours_6"
                              onChange={onChangeEtudiant}
                              value={etudiant.moyenne_concours_6}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="annee_scolaire">
                              Année Scolaire
                            </Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="annee_scolaire"
                              name="annee_scolaire"
                              onChange={onChangeEtudiant}
                              value={etudiant.annee_scolaire}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="etablissement_frequente">
                              Etablissement Fréquenté
                            </Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="etablissement_frequente"
                              name="etablissement_frequente"
                              onChange={onChangeEtudiant}
                              value={etudiant.etablissement_frequente}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="moyenne_trimestre_1">
                              Moyenne 1er Trimestre
                            </Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="moyenne_trimestre_1"
                              name="moyenne_trimestre_1"
                              onChange={onChangeEtudiant}
                              value={etudiant.moyenne_trimestre_1}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="moyenne_trimestre_2">
                              Moyenne 2ème Trimestre
                            </Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="moyenne_trimestre_2"
                              name="moyenne_trimestre_2"
                              onChange={onChangeEtudiant}
                              value={etudiant.moyenne_trimestre_2}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col lg={4}>
                            <Form.Label htmlFor="moyenne_trimestre_3">
                              Moyenne 3ème Trimestre
                            </Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="moyenne_trimestre_3"
                              name="moyenne_trimestre_3"
                              onChange={onChangeEtudiant}
                              value={etudiant.moyenne_trimestre_3}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4}>
                            <Form.Label htmlFor="moyenne_annuelle">
                              Moyenne Annuelle
                            </Form.Label>
                          </Col>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="moyenne_annuelle"
                              name="moyenne_annuelle"
                              onChange={onChangeEtudiant}
                              value={etudiant.moyenne_annuelle}
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <div className="hstack gap-2 justify-content-end">
                    <Button
                      variant="light"
                      onClick={() => {
                        tog_AddEtudiant();
                        setEtudiant(initialEtudiant);
                      }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      id="addNew"
                    >
                      <i className="ri-check-line me-1" />
                      Enregistrer
                    </Button>
                  </div>
                </Row>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Bulk Change Classe Modal */}
          <Modal
            show={modal_BulkClasse}
            onHide={() => setModal_BulkClasse(false)}
            centered
          >
            <Modal.Header closeButton className="bg-warning-subtle">
              <h5 className="modal-title">
                <i className="ri-exchange-line me-2" />
                Changer de classe ({selectedRows.length} élève(s))
              </h5>
            </Modal.Header>
            <Modal.Body>
              <p className="text-muted mb-3">
                Sélectionnez la nouvelle classe pour les <strong>{selectedRows.length}</strong> élève(s) sélectionné(s) :
              </p>
              <div className="mb-3">
                <h6 className="text-muted mb-2">Élèves concernés :</h6>
                <div className="d-flex flex-wrap gap-1" style={{ maxHeight: "120px", overflowY: "auto" }}>
                  {selectedRows.map((r: any) => (
                    <Badge key={r._id} bg="light" text={"dark" as any} className="border fs-12">
                      {r.prenom} {r.nom}
                      <span className="text-muted ms-1">({r.classe?.nom_classe || "—"})</span>
                    </Badge>
                  ))}
                </div>
              </div>
              <Form.Group>
                <Form.Label className="fw-semibold">Nouvelle classe</Form.Label>
                <select
                  className="form-select"
                  value={bulkTargetClasse}
                  onChange={(e) => setBulkTargetClasse(e.target.value)}
                >
                  <option value="">— Choisir une classe —</option>
                  {[...AllClasses].sort((a: any, b: any) => (a.nom_classe || "").localeCompare(b.nom_classe || "", "fr")).map((c: any) => (
                    <option value={c._id} key={c._id}>{c.nom_classe}</option>
                  ))}
                </select>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={() => setModal_BulkClasse(false)}>
                Annuler
              </Button>
              <Button
                variant="warning"
                disabled={!bulkTargetClasse}
                onClick={handleBulkChangeClasse}
              >
                <i className="ri-check-line me-1" />
                Déplacer {selectedRows.length} élève(s)
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Import Modal */}
          <Modal
            className="fade"
            show={modal_Import}
            onHide={() => setmodal_Import(false)}
            centered
            size="xl"
          >
            <Modal.Header closeButton className="bg-info-subtle">
              <h5 className="modal-title">
                <i className="ri-upload-2-line me-2" />
                Importer des Élèves via Excel
              </h5>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3">
                <p className="text-muted mb-2">
                  1. Téléchargez le <strong>Template Excel</strong>.<br/>
                  2. Remplissez les colonnes obligatoires : <code>nom_eleve</code>, <code>prenom_eleve</code>, <code>genre</code>, <code>classe</code>, <code>nom_parent</code>, <code>prenom_parent</code>, <code>phone_parent</code>.<br/>
                  3. La détection du genre et du nom de classe est tolérante (ex: "garcon" → "Mâle", "6 eme A" → "6A").<br/>
                  4. Si un parent avec le même téléphone existe déjà, l'élève sera lié à ce parent.
                </p>
              </div>
              <Form.Group className="mb-3">
                <Form.Label>Fichier Excel (.xlsx)</Form.Label>
                <Form.Control
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileImport}
                />
              </Form.Group>

              {validatedRows.length > 0 && (
                <>
                  <div className="d-flex gap-2 mb-3">
                    <span className={`badge bg-${allValid ? "success" : "warning"} fs-14 p-2`}>
                      {validatedRows.length} ligne(s) analysée(s)
                    </span>
                    <span className="badge bg-success fs-14 p-2">
                      <i className="ri-check-line me-1"></i>{validCount} valide(s)
                    </span>
                    {errorCount > 0 && (
                      <span className="badge bg-danger fs-14 p-2">
                        <i className="ri-error-warning-line me-1"></i>{errorCount} erreur(s)
                      </span>
                    )}
                  </div>

                  <div className="table-responsive" style={{ maxHeight: "400px" }}>
                    <table className="table table-sm table-bordered mb-0">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th style={{width: "40px"}}>#</th>
                          <th style={{width: "30px"}}></th>
                          <th>Nom élève</th>
                          <th>Prénom élève</th>
                          <th>Genre</th>
                          <th>Classe</th>
                          <th>Nom parent</th>
                          <th>Prénom parent</th>
                          <th>Tél parent</th>
                          <th style={{width: "200px"}}>Erreurs</th>
                        </tr>
                      </thead>
                      <tbody>
                        {validatedRows.map((row) => (
                          <tr key={row.index}>
                            <td className="text-muted">{row.index + 1}</td>
                            <td className="text-center">
                              {row.valid ? (
                                <i className="ri-checkbox-circle-fill text-success fs-16"></i>
                              ) : (
                                <i className="ri-close-circle-fill text-danger fs-16"></i>
                              )}
                            </td>
                            <td className={getCellClass(row, "nom_eleve")} title={getCellTooltip(row, "nom_eleve")}>
                              {row.normalized.nom_eleve || <span className="text-danger fst-italic">vide</span>}
                            </td>
                            <td className={getCellClass(row, "prenom_eleve")} title={getCellTooltip(row, "prenom_eleve")}>
                              {row.normalized.prenom_eleve || <span className="text-danger fst-italic">vide</span>}
                            </td>
                            <td className={getCellClass(row, "genre")} title={getCellTooltip(row, "genre")}>
                              {row.corrected.genre ? (
                                <>{row.corrected.genre} <i className="ri-arrow-left-s-line text-muted"></i> <small className="text-muted">{row.original.genre}</small></>
                              ) : (
                                row.normalized.genre || <span className="text-danger fst-italic">vide</span>
                              )}
                            </td>
                            <td className={getCellClass(row, "classe")} title={getCellTooltip(row, "classe")}>
                              {row.corrected.classe ? (
                                <>{row.corrected.classe} <i className="ri-arrow-left-s-line text-muted"></i> <small className="text-muted">{row.original.classe}</small></>
                              ) : (
                                row.normalized.classe || <span className="text-danger fst-italic">vide</span>
                              )}
                            </td>
                            <td className={getCellClass(row, "nom_parent")} title={getCellTooltip(row, "nom_parent")}>
                              {row.normalized.nom_parent || <span className="text-danger fst-italic">vide</span>}
                            </td>
                            <td className={getCellClass(row, "prenom_parent")} title={getCellTooltip(row, "prenom_parent")}>
                              {row.normalized.prenom_parent || <span className="text-danger fst-italic">vide</span>}
                            </td>
                            <td className={getCellClass(row, "phone_parent")} title={getCellTooltip(row, "phone_parent")}>
                              {row.normalized.phone_parent || <span className="text-danger fst-italic">vide</span>}
                            </td>
                            <td>
                              {row.errors.length > 0 && (
                                <ul className="list-unstyled mb-0 small">
                                  {row.errors.map((err, ei) => (
                                    <li key={ei} className="text-danger">
                                      <strong>{err.field}</strong>: {err.message}
                                      {err.suggestion && <span className="text-warning d-block">{err.suggestion}</span>}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {importResult && importResult.errors?.length > 0 && (
                <div className="alert alert-warning mt-3">
                  <strong>Erreurs serveur :</strong>
                  <ul className="mb-0 mt-1">
                    {importResult.errors.map((err: any, idx: number) => (
                      <li key={idx}>Ligne {err.row}: {err.message}</li>
                    ))}
                  </ul>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={() => setmodal_Import(false)}>
                Fermer
              </Button>
              <Button
                variant="success"
                disabled={!allValid || importLoading}
                onClick={handleBulkImport}
              >
                {importLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Import en cours...
                  </>
                ) : allValid ? (
                  <>
                    <i className="ri-upload-2-line me-1"></i>
                    Importer {validCount} élève(s)
                  </>
                ) : (
                  <>
                    <i className="ri-error-warning-line me-1"></i>
                    Corrigez les erreurs pour importer
                  </>
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Etudiants;
